import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import videoES from "../../assets/app/VideoContainer/TuAgenteVirtual.mp4";
import videoEN from "../../assets/app/VideoContainer/TuAgenteVirtualEn.mp4"; // Placeholder, replace with English video path
import logoIMG from "../../assets/app/VideoContainer/poster.png";
import "../../styles/app/VideoContainer.css";
import { ThemeContext } from "../../contexts/ThemeContext";

const VideoContainer: React.FC = () => {
  const { i18n } = useTranslation();

  const videoSrc = i18n.language === "es" ? videoES : videoEN;

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  return (
    <section
      className="video-container"
      data-theme={isLightMode ? "light" : "dark"}
    >
      <video controls poster={logoIMG} key={videoSrc}>
        {" "}
        {/* Add key to force re-render on src change */}
        <source src={videoSrc} type="video/mp4" />
        Tu navegador no soporta el video.
      </video>
    </section>
  );
};

export default VideoContainer;
